import React from 'react';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { DndProvider } from 'react-dnd'
import { TouchBackend } from "react-dnd-touch-backend";


import { createRoot } from 'react-dom/client';
const container = document.getElementById('app');
const root = createRoot(container);

root.render(

  <DndProvider debugMode={true} backend={TouchBackend} options={{ enableMouseEvents: true }}>
    <App />
  </DndProvider>

);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
